import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetCmsSubmissionsByRreQuery } from "services/rre-api";
import Table from "components/Table/Table";
import type { CMSTransmissionLogType } from "types/DataTypes";
import { useDispatch } from "utils/redux";
import { setIsLoading } from "reducers/main";
import { setValidationState } from "reducers/main";
import { useGetRreValidationsQuery } from "services/rre-api";
import DownloadLink from "components/common/DownloadLink.tsx";
import RREPageContainer from "./RREPageContainer";

const CMS_SUBMISSIONS_COLUMNS = [
  { key: "id", name: "ID" },
  // { key: "rre_id", name: "RRE ID" },
  { key: "cause_verbose", name: "Cause" },
  { key: "is_testing_verbose", name: "Test" },
  { key: "triggered_by_name", name: "Triggered By" },
  { key: "trans_type_verbose", name: "Type" },
  { key: "item_count", name: "Items" },
  { key: "send_date", name: "Send Date" },
  { key: "send_status_verbose", name: "Send Status" },
  { key: "response_date", name: "Response Date" },
  { key: "response_status_verbose", name: "Response Status" },
  { key: "error_details", name: "Error Details" },
  {
    key: "actions",
    name: "Actions",
    renderCell(props) {
      const isSubmittedDownloadDisabled = props?.row?.submitted_file_url
        ? false
        : true;
      const isResponseDownloadDisabled = props?.row?.response_file_url
        ? false
        : true;
      return (
        <>
          <DownloadLink
            url={props?.row?.submitted_file_url}
            icon="download"
            filename={`${props?.row.rre_id}-submitted-${props?.row.trans_type_verbose.toLowerCase()}-${props?.row.id}.txt`}
            title={
              isSubmittedDownloadDisabled
                ? "Download not available"
                : "Download Submitted File"
            }
            disabled={isSubmittedDownloadDisabled}
          />
          <DownloadLink
            url={props?.row?.response_file_url}
            icon="downloading"
            filename={`${props?.row.rre_id}-response-${props?.row.trans_type_verbose.toLowerCase()}-${props?.row.id}.txt`}
            title={
              isResponseDownloadDisabled
                ? "Download not available"
                : "Download Response File"
            }
            disabled={isResponseDownloadDisabled}
          />
        </>
      );
    },
  },
];

const CmsSubmissions = () => {
  const { rreId } = useParams<{ rreId?: string }>();
  const dispatch = useDispatch();

  const { data, isLoading } = useGetCmsSubmissionsByRreQuery(
    { id: rreId },
    { skip: !rreId },
  );

  useEffect(() => {
    dispatch(setIsLoading(isLoading));
  }, [dispatch, isLoading]);

  const { data: rreValidation } = useGetRreValidationsQuery(
    { id: rreId },
    { skip: !rreId },
  );

  useEffect(() => {
    if (rreValidation) {
      const validationData = Object.values(rreValidation).flat();
      const errors = validationData.filter((item) => item.level === "ERROR");
      const warnings = validationData.filter((item) => item.level === "WARN");
      dispatch(
        setValidationState({
          errors: errors,
          warnings: warnings,
        }),
      );
    }
  }, [dispatch, rreValidation]);

  return (
    <RREPageContainer>
      <Table
        className="rre-table"
        columns={CMS_SUBMISSIONS_COLUMNS}
        // @ts-expect-error TODO: fix this
        rows={data?.results || []}
        sortColumns={[]}
        rowKeyGetter={(row: CMSTransmissionLogType) => row.id}
      />
    </RREPageContainer>
  );
};

export default CmsSubmissions;
